var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { State } from "./State";
import { merge } from "rxjs";
import { filter, map } from "rxjs/operators";
var DerivedState = /** @class */ (function (_super) {
    __extends(DerivedState, _super);
    function DerivedState(inputState, stream, isNonValue, defaultNonValue, defaultWhenInputHasNonValue) {
        var _this = this;
        var afterConnect = function (state, setStateFn) {
            if (!state.hasValue()) {
                setStateFn(defaultWhenInputHasNonValue);
            }
        };
        var afterDisConnect = function (state, setStateFn) {
            setStateFn(defaultNonValue);
        };
        _this = _super.call(this, stream, isNonValue, afterConnect, afterDisConnect) || this;
        _this.inputState = inputState;
        _this.defaultWhenInputHasNonValue = defaultWhenInputHasNonValue;
        return _this;
    }
    return DerivedState;
}(State));
export { DerivedState };
export function deriveRaw(state, transformer) {
    var transformed = transformer(state.outputStreamTrailing, state);
    var isNonValue = function (val) {
        return val === undefined;
    };
    return new DerivedState(state, transformed, isNonValue, undefined, undefined);
}
export function derive(state, transformer, defaultWhenInputHasNonValue) {
    var valueStream$ = state.outputStreamTrailing.pipe(filter(function (v) { return !state.isNonValue(v); }));
    var values$ = transformer(valueStream$, state);
    var nonValues$ = state.outputStreamTrailing.pipe(filter(function (v) { return state.isNonValue(v); }), map(function (_) { return undefined; }));
    var source$ = merge(values$, nonValues$);
    var isNonValue = function (val) {
        return val === undefined;
    };
    return new DerivedState(state, source$, isNonValue, undefined, defaultWhenInputHasNonValue);
}
